export default function getErrorMessage(
  error,
  fallback = "Something went wrong"
) {
  if (!error) return fallback;

  if (typeof error === "string") return error;

  const genericBackendMessages = new Set([
    "Exception",
    "ValueError",
    "TypeError",
    "AttributeError",
    "RuntimeError",
    "Conflict",
  ]);

  let data = error?.data;

  if (typeof data === "string") {
    try {
      data = JSON.parse(data);
    } catch {
      data = { message: data };
    }
  }

  const message = data?.message;
  const verbose = data?.verbose;

  if (message && !genericBackendMessages.has(message)) {
    return message;
  }

  return verbose || message || error?.error || error?.message || fallback;
}
